import { render, staticRenderFns } from "./LotViewSkeleton.vue?vue&type=template&id=22a0402a&scoped=true"
import script from "./LotViewSkeleton.vue?vue&type=script&lang=js"
export * from "./LotViewSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a0402a",
  null
  
)

export default component.exports